import { render, staticRenderFns } from "./MainText.vue?vue&type=template&id=7cc26eba"
import script from "./MainText.vue?vue&type=script&lang=js"
export * from "./MainText.vue?vue&type=script&lang=js"
import style0 from "./MainText.vue?vue&type=style&index=0&id=7cc26eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports